import throttle from 'lodash.throttle';

/**
 * Set CSS custom properties that allow for consistent cross-browser
 * calculations of viewport-units.
 * @usage: calc(var(--vh) * 100) = 100vh, calc(var(--vw) * 100) = 100vw
 */
"use strict";

export function viewportUnits() {

  /**
   * Calculate real height of vh unit.
   * @see https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
   */
  let setVh = function() {
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    let vh = Number.parseFloat( window.innerHeight * 0.01 ).toFixed( 2 );

    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty( '--vh', `${vh}px` );
  }


  /**
   * Calculate real width of vw unit, taking into consideration scrollbars.
   * @see https://codepen.io/bassplayer7/pen/egZKpm
   */
  let setVw = function() {
    let body = document.querySelector( 'body' );
    let vw = Number.parseFloat( ( window.innerWidth - ( window.innerWidth - body.clientWidth ) ) * 0.01 ).toFixed( 2 );
    document.documentElement.style.setProperty( '--vw', `${vw}px` );
  }

  let calculate = function() {
    setVh();
    setVw();
  }

  let throttledCalculate = throttle( calculate, 100 );

  // Init on load.
  calculate();

  // Handle change in window size.
  window.addEventListener( 'resize', throttledCalculate );
  window.addEventListener( 'orientationchange', throttledCalculate );

}
